export const locale = {
    lang: 'en',
    data: {
        CHAT: {
            SIDEBAR: {
                TITLE: 'Chat',
            },
        },
    },
};
